
import { AdminStatsCards } from "./AdminStatsCards";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle, Users, ListFilter, Settings, BarChart3, Settings2, User } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAdminAccess } from "@/hooks/useAdminAccess";

export const AdminDashboard = () => {
  const navigate = useNavigate();
  const { isSuperAdmin } = useAdminAccess();

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            Super Admin Dashboard
          </h1>
          <p className="text-muted-foreground">
            Manage all aspects of the Property LK platform
          </p>
        </div>
      </div>

      <AdminStatsCards />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl flex items-center gap-2">
              <ListFilter className="h-5 w-5" />
              Property Listings
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              Manage all property listings across the platform
            </p>
            <Button 
              onClick={() => navigate('/admin/listings')} 
              className="w-full"
            >
              Go to Listings
            </Button>
          </CardContent>
        </Card>

        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl flex items-center gap-2">
              <Users className="h-5 w-5" />
              User Management
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              Manage all users, roles and permissions
            </p>
            <Button 
              onClick={() => navigate('/admin/users')} 
              className="w-full"
            >
              Go to User Management
            </Button>
          </CardContent>
        </Card>

        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl flex items-center gap-2">
              <Settings2 className="h-5 w-5" />
              System Settings
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              Configure system-wide settings and preferences
            </p>
            <Button
              onClick={() => navigate('/admin/settings')}
              className="w-full"
              variant="outline"
            >
              Go to Settings
            </Button>
          </CardContent>
        </Card>

        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl flex items-center gap-2">
              <PlusCircle className="h-5 w-5" />
              Create New Listing
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              Add a new property listing to the platform
            </p>
            <Button 
              onClick={() => navigate('/admin/create-listing')} 
              className="w-full"
              variant="outline"
            >
              Create Listing
            </Button>
          </CardContent>
        </Card>
        
        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl flex items-center gap-2">
              <User className="h-5 w-5" />
              Create New User
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              Add a new user or administrator to the platform
            </p>
            <Button 
              onClick={() => navigate('/admin/create-user')} 
              className="w-full"
              variant="outline"
            >
              Create User
            </Button>
          </CardContent>
        </Card>
        
        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl flex items-center gap-2">
              <BarChart3 className="h-5 w-5" />
              Analytics & Reports
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              View detailed analytics and generate reports
            </p>
            <Button 
              onClick={() => navigate('/admin/analytics')} 
              className="w-full"
              variant="outline"
            >
              View Analytics
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminDashboard;
